import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  dealerType: null,
}

export const dealerTypeSlice = createSlice({
  initialState,
  name: 'dealerTypeSlice',
  reducers: {
    setDealerType: (state, action) => {
      state.dealerType = action.payload
    },
  },
})

export default dealerTypeSlice.reducer

export const { setDealerType } = dealerTypeSlice.actions
